import { initStatsigClient } from "./client";
import { bindStatsigEventAttributes } from "./eventAttributes";
export { getStatsigStableID } from "./client";
export { getStatsigUser } from "./user";
export { logEvent, logEventAndFlush } from "./events";
export { bindStatsigEventAttributes } from "./eventAttributes";
export { getExperimentParamWithGroupName, getForcedExperimentFlag, getForcedExperimentValue, logExperimentExposure, } from "./experiments";
export { applyExperimentAttributes } from "./experimentAttributes";
export { getStatsigDebugSnapshot, getStatsigExperimentDebugSnapshot } from "./debug";
export async function initStatsig(options = {}) {
    const client = await initStatsigClient(options);
    bindStatsigEventAttributes();
    return client;
}
